// @ts-nocheck
import { CaseSortColumnType } from './types';
import { SortColumnDirectionType } from '../shared/types';
import { TypeCodeTranslation } from '../../business/models/shared.model';

export class CaseResponse {
  [key: string]: any; // Add this line to allow string indexing

  public instructionId = 0;
  public taskType = '';
  public visitDate: Date | string;
  public caseCode = '';
  public expertName = '';
  public damageCauseIcon = '';
  public insuredPersonName = '';
  public causeOfDamage = '';
  public damageCauseDescription = '';
  public insurer = '';
  public sizeOfDamage = '';
  public againstParty = '';
  public claimNotificationId: number;
  public taskId: number;
  public refuseReasonTC = '';
  public refuseReasonText = '';
  public archived = false;
  public assignedUserId = 0;
  public offline = false;
  public damageIcon = '';
  public approved = false;
  public hasHonoraryNote = false;
  public isRead = false;
  public policySubTypeTC = '';
  public createdOn: Date | string;
  public riskAddressId: number;
  public riskCity = '';
  public riskStreet = '';
  public riskBuildingNumber = '';
  public riskBoxNumber = '';
  public riskZipCode = '';
  public addressId: number | null;
  public telephone = '';
  public mobile = '';
  public policyHolderCity = '';
  public policyHolderStreet = '';
  public policyHolderBuildingNumber = '';
  public policyHolderBoxNumber = '';
  public policyHolderZipCode = '';
  public policyHolderLanguageTC = '';
  public blocked = true;
  public agendaReference = '';
  public responsibleInsurerCaseNumber = '';
  public responsiblePartyLicensePlate = '';
  public responsiblePartyPolicyType = '';
  public responsiblePartyInsurerName = '';
  public allApproved = false;
  public anythingForApproval = false;
  public allHnApproved = false;
  public anyHnForApproval = false;
  public parentPartyDibCode = '';
  public parentPartyName  = '';
  public inProgress = false;
  public instructionText = '';
}

// export interface CaseSearch {
//   fetchSize: number;
//   offset: number;
//   sortColumn: CaseSortColumnType;
//   sortDirection: SortColumnDirectionType;
//   caseCode: string;
//   taskType: string;
//   archived: boolean;
//   agendaRef: string;
//   policyHolder: string;
//   insuredPersonData: string;
//   causeOfDamage: string;
//   insurer: string;
//   sizeOfDamage: number;
//   againstParty: boolean;
//   hasDocumentForApproval: boolean;
//   hasUnassignedUser: boolean;
//   hasMissingHonoraryNote: boolean;
//   assignedToPartyId: number | undefined;
//   assignedParties: PartyResponse[];
//   parties: PartyResponse[];
//   childParties: PartyResponse[];
//   selectedPartyId: number;
//   selectedChildPartyId: number;
//   inProgressOnly: boolean | undefined;
//   belongsToPartyId: number;
//   belongsToChildPartyId: number;
// }

export class CaseSearch {
  public fetchSize = 15;
  public offset = 0;
  public sortColumn: CaseSortColumnType = 'START_DATE';
  public sortDirection: SortColumnDirectionType = 'DESC';
  public caseCode = '';
  public taskType = '';
  public archived = false;
  public agendaRef = '';
  public policyHolder = '';
  public insuredPersonData = '';
  public causeOfDamage = '';
  public insurer = '';
  public sizeOfDamage = '';
  public againstParty = '';
  public hasDocumentForApproval = false;
  public hasUnassignedUser = false;
  public hasMissingHonoraryNote = false;
  public assignedToPartyId = 0;
  public assignedParties: PartyResponse[] = [];
  public parties: PartyResponse[] = [];
  public childParties: PartyResponse[] = [];
  public selectedPartyId = 0;
  public selectedChildPartyId = 0;
  public inProgressOnly = false;
}

export enum CaseSearchParam {
  HasDocumentForApproval = 1,
  HasHonoraryNoteMissing = 2,
  HasUnassignedUser = 3
}

export class CaseTypeCodes {
  public refuseReasons: TypeCodeTranslation[] = [];
  public taskTypeList: TypeCodeTranslation[] = [];
}

export class UserAccountResponse {
  public userId: number = 0;
  public userFullName: string = '';
}

export class CaseCountResponse {
  countOfOpened: number = 0;
  countOfArchived: number = 0;
  countOfHasDocForApproval: number = 0;
  countOfHonoraryNoteMissing: number = 0;
  countOfUnassigned: number = 0;
}

export class PartyResponse {
  public id: number = 0;
  public assignedPartyCode: number = 0;
  public firstName: string = '';
  public lastName: string = '';
  public partyName: string = '';
}
